import Homedetails from "./components/homepage";
import Profile from "./components/profile";
const Home=()=>{
return(
    <div className="Home">
        {/* <div className="Bg_div"><img className="bg_img" src={bgimg} alt=""/></div> */}
        <Profile/>
        <Homedetails/>
    </div>
);
};
export default Home;